import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, COMPANY } from "../../mock";
import { Button } from "../ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "../ui/sheet";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-lg border-b border-slate-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div data-testid="nav-logo-mark" className="h-9 w-9 rounded-xl bg-sky-500 text-white flex items-center justify-center font-bold text-sm tracking-tight">
            AW
          </div>
          <div className="leading-tight">
            <div className="font-semibold text-slate-900 text-[15px]">
              {COMPANY.name}
            </div>
            <div className="text-[11px] text-slate-500 -mt-0.5">
              Social Media Consultancy & Technical Solutions
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm text-slate-700 hover:text-slate-900 transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-slate-900 group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button
            asChild
            className="bg-slate-900 hover:bg-slate-800 text-white rounded-full px-5 group"
          >
            <a href="/#contact">
              Start a project
              <ArrowUpRight className="ml-1 h-4 w-4 btn-arrow" />
            </a>
          </Button>
        </div>

        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                aria-label="Open menu"
                className="h-10 w-10 inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white"
              >
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[85vw] sm:w-[400px] bg-white">
              <div className="flex flex-col h-full">
                <div className="flex items-center gap-2 pb-6 border-b">
                  <div className="h-9 w-9 rounded-xl bg-sky-500 text-white flex items-center justify-center font-bold text-sm">
                    AW
                  </div>
                  <div className="font-semibold">{COMPANY.name}</div>
                </div>
                <nav className="flex flex-col gap-1 pt-6">
                  {NAV_LINKS.map((l) => (
                    <a
                      key={l.label}
                      href={l.href}
                      onClick={() => setOpen(false)}
                      className="py-3 px-2 rounded-lg text-slate-800 hover:bg-slate-100 text-base"
                    >
                      {l.label}
                    </a>
                  ))}
                </nav>
                <div className="mt-auto pt-6 border-t space-y-3">
                  <a
                    href={`mailto:${COMPANY.email}`}
                    className="block text-sm text-slate-600"
                  >
                    {COMPANY.email}
                  </a>
                  <Button
                    asChild
                    className="w-full bg-slate-900 hover:bg-slate-800 rounded-full"
                  >
                    <a href="/#contact" onClick={() => setOpen(false)}>
                      Start a project
                    </a>
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
